import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { sideBar } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { LoginResponse } from '../../models/loginResponse.model';
import { userRole } from '../../core/constants/keys.constant';
import { SideBar } from '../../models/sideBar.model';
import { ModuleConst } from '../../core/constants/module.const';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'tusangaire-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  protected assetsConst = assets;
  protected sideBar = sideBar;
  protected moduleConst = ModuleConst;
  protected subscriptionSubject$: Subscription;
  protected destroy$: Subject<boolean> = new Subject<boolean>();
  protected innerWidth = 0;
  protected sidenavWidth = 5;

  constructor(private _authService: AuthService, public router: Router) {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.handleSideBar(res);
        }
      });
  }

  private handleSideBar(res: LoginResponse): void {
    if (res.role !== userRole.Admin) {
      this.subAdminRoleHandler(res);
    } else {
      this.sideBar.forEach((el: SideBar) => {
        el.isView = el.isAdd = el.isEdit = el.isDelete = true;
      });
    }
  }
  private subAdminRoleHandler(res: LoginResponse): void {
    const removeableItems = new Set([this.moduleConst.SUBADMIN]);
    const permissions = res.permission || res.accessRole?.permission || [];

    const matchId = (a: string | number | undefined, b: string | number | undefined): boolean => Number(a) === Number(b);

    this.sideBar = this.sideBar.filter(item => {
      if (removeableItems.has(item.sideBarId)) {
        return false;
      }
      const current = permissions.find(el => matchId(el.sideBarId, item.sideBarId));
      if (current) {
        Object.assign(item, {
          isView: current.isView,
          isAdd: current.isAdd,
          isEdit: current.isEdit,
          isDelete: current.isDelete
        });
      }

      if (item.isSubMenu && item.subMenuItems) {
        let hasAnySubView = false;
        item.subMenuItems.forEach(sub => {
          const subCurrent = permissions.find(el => matchId(el.sideBarId, sub.sideBarId));
          if (subCurrent) {
            sub.isView = subCurrent.isView;
            sub.isAdd = subCurrent.isAdd;
            sub.isEdit = subCurrent.isEdit;
            sub.isDelete = subCurrent.isDelete;
          } else if (item.isView) {
            sub.isView = true;
          }
          if (sub.isView) {
            hasAnySubView = true;
          }
        });
        if (hasAnySubView) {
          item.isView = true;
        }
      }

      return item.isView !== false;
    });
  }

  // handleSideBar(res: LoginResponse): void {
  //   if (res.role === Role.SUBADMIN) {
  //     const removeableItems = new Set([ModuleConst.SubAdmin]); // SideBar Id of items to remove

  //     this.sideBar = this.sideBar.filter(item => {
  //       if (removeableItems.has(item.sideBarId)) {
  //         return false; // Exclude items to be removed
  //       }

  //       const current = res.permission?.find(
  //         el => el.sideBarId === item.sideBarId
  //       );
  //       if (current) {
  //         Object.assign(item, {
  //           isView: current.isView,
  //           isAdd: current.isAdd,
  //           isEdit: current.isEdit,
  //           isDelete: current.isDelete
  //         });
  //       }

  //       return true; // Keep items that are not removed
  //     });
  //   } else {
  //     this.sideBar.forEach((el: sidebarInterface) => {
  //       el.isView = el.isAdd = el.isEdit = el.isDelete = true;
  //     });
  //   }
  // }

  increase(): void {
    this.sidenavWidth = 15;
  }

  decrease(): void {
    this.sidenavWidth = 4;
  }

  isParentActive(item: SideBar): boolean {
    if (!item.isSubMenu || !item.subMenuItems) {
      return false;
    }
    const currentUrl = this.router.url;
    return item.subMenuItems.some(sub => sub.path && currentUrl.includes(sub.path));
  }

  @HostListener('window:resize')
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1200) {
      this._authService.toggleSidebarView();
    }
  }
}
